export default __webpack_public_path__ + "static/media/abtLiz.828712fd.jpg";